import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import {
  OneClickPaymentProvider,
  OneClickHasResultProvider,
  OneClickNoResultProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClickDeliveryMethodProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-method.provider';
import { OneClickLocationDisplayer } from '../../../../providers/order/one-click-multiple-jobsite-displayer.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';
import { OneClickLocationProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-location.provider';
import { FormSelectComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/form-select.component';
import { FieldSelectConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-multiselect/models/field-select-config.interface';
import { OneClickSetTimeWindow } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-time-window.command.service';
import { OneClickTimeWindowsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-time-windows.effects';
import { OneClickTimeWindowsLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-time-windows.loader.service';
import { OneClickPreviewTimeWindowLoadingProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-preview-time-windows-loading.provider';
import { Validators } from '@angular/forms';
import { OneClickTimeWindowProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-time-window.provider';
import { OneClickFeatureConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-feature-config';
import { OneClickElement } from '@ordersnproducts/modules/one-click-order/util/enums/one-click-element';
import { OneClickElementConfig } from '@ordersnproducts/modules/one-click-order/models/one-click-element-config';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpointofdelivery',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpointofdelivery',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    containerClassNames: ['col-md-8 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.StandardLot,
    text: OneClickStandardLotProvider,
    label: 'views.specification.std_lot',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagstdlotsize',
    dataTIdValue: 'cmx-createoneclickorder-lblvalstdlotsize',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryMethod,
    text: OneClickDeliveryMethodProvider.TextPreview,
    label: 'views.one_click.delivery_method',
    containerClassNames: ['col-md-8 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliverymethod',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliverymethod',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickPaymentProvider,
    label: 'views.one_click.payment_method',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
  } as FieldLabelConfig,
  {
    type: FormSelectComponent,
    name: OneClickPreviewField.TimeWindow,
    label: 'views.one_click.time_window',
    placeholder: 'views.one_click.select_time_window',
    optionsLoader: OneClickTimeWindowsLoaderService,
    loading: OneClickPreviewTimeWindowLoadingProvider,
    hidden: OneClickHasResultProvider,
    dynamicEffects: [OneClickTimeWindowsEffects],
    onChange: [OneClickSetTimeWindow],
    containerClassNames: ['col-md-4 text-capitalize retail-control'],
    validation: [Validators.required],
    dataTIdLabel: 'cmx-createoneclickorder-seltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-selvaltimewindow',
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.TimeWindow,
    text: OneClickTimeWindowProvider,
    label: 'views.one_click.time_window',
    hidden: OneClickNoResultProvider,
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagtimewindow',
    dataTIdValue: 'cmx-createoneclickorder-lblvaltimewindow',
  } as FieldLabelConfig,
];

export const features: OneClickFeatureConfig = {
  [OneClickElement.TERMS_AND_CONDITIONS]: {
    name: OneClickElement.TERMS_AND_CONDITIONS,
  } as OneClickElementConfig,
};
